var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAjaxLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2000,
    height: 960,
    xmlns: "http://www.w3.org/2000/svg",
    desc: "Created with imagetracer.js version 1.2.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,0,0)",
    stroke: "rgb(0,0,0)",
    strokeWidth: 1,
    opacity: 0,
    d: "M 0 0 L 2000 0 L 2000 960 L 0 960 L 0 0 Z M 680 77 L 679 78 L 671 78 L 654 81 L 634 88 Q 614 97 600 110 Q 585 123 575 140 L 563 166 L 559 181 L 558 194 L 557 195 L 557 520 L 547 513 L 493 466 Q 490 465 491 468 L 489 468 L 489 470 L 443 517 Q 444 519 441 518 L 446 525 L 443 529 L 444 531 Q 443 533 446 532 L 603 690 L 603 691 L 605 691 L 648 649 L 768 530 L 765 526 L 770 518 L 769 518 L 712 466 L 658 520 L 654 520 L 654 210 Q 658 192 668 181 Q 683 161 713 155 L 790 155 Q 809 159 822 169 Q 840 183 847 209 L 847 249 L 849 250 L 849 258 L 958 258 L 958 250 L 960 248 L 960 208 L 960 206 L 959 205 L 958 185 L 952 162 Q 944 139 929 123 Q 902 90 854 79 L 838 78 L 837 77 L 680 77 Z M 904 279 L 851 331 L 851 332 L 849 332 Q 850 335 848 334 L 845 338 L 844 338 L 793 388 L 790 392 L 787 394 L 784 398 L 783 398 L 739 442 L 744 448 L 740 453 L 797 504 L 851 450 L 854 450 L 854 759 Q 850 777 840 790 Q 833 799 822 806 L 803 814 L 790 815 L 789 816 L 727 816 L 726 815 L 718 815 Q 697 811 685 799 L 670 782 L 663 765 L 661 754 L 661 712 L 549 712 L 549 767 L 550 768 L 551 784 L 554 799 Q 563 831 584 853 Q 602 872 628 883 L 650 890 L 661 892 L 669 892 L 670 893 L 831 893 L 832 892 L 841 892 Q 881 885 907 862 Q 928 844 940 817 L 948 792 L 950 771 L 951 770 L 951 450 L 954 450 L 959 454 L 1017 504 L 1066 452 L 1063 450 L 1062 448 L 1067 442 L 904 279 Z M 1480 454 L 1487 464 L 1487 465 L 1482 465 L 1485 471 L 1636 662 L 1471 861 L 1463 872 L 1471 873 L 1465 880 L 1466 881 L 1612 881 L 1709 741 L 1808 881 L 1945 881 L 1939 873 L 1947 872 L 1777 660 L 1928 475 L 1934 465 L 1929 465 L 1937 455 L 1799 454 L 1707 584 L 1623 458 L 1620 454 L 1480 454 Z M 244 455 L 59 870 L 59 871 L 64 871 L 61 878 L 62 880 L 182 880 L 186 872 L 217 794 L 219 792 L 402 792 L 437 879 L 439 880 L 559 880 L 556 871 L 561 871 L 376 457 L 375 455 L 244 455 Z M 1138 455 L 1133 463 L 993 779 L 962 846 L 952 871 L 957 872 L 953 879 L 954 880 L 1075 880 L 1110 795 L 1111 792 L 1294 792 L 1297 798 L 1330 879 L 1331 880 L 1451 880 L 1448 872 L 1453 871 L 1453 869 L 1268 457 L 1268 455 L 1138 455 Z "
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,0,0)",
    stroke: "rgb(0,0,0)",
    strokeWidth: 1,
    opacity: 0,
    d: "M 310.5 566 L 368 708.5 L 280.5 709 L 279.5 710 L 254 710 L 310.5 566 Z "
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,0,0)",
    stroke: "rgb(0,0,0)",
    strokeWidth: 1,
    opacity: 0,
    d: "M 1203.5 567 L 1260 709 L 1172.5 709 L 1171.5 710 L 1146.5 710 L 1147 708.5 L 1187 605.5 L 1203.5 567 Z "
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(14,78,120)",
    stroke: "rgb(14,78,120)",
    strokeWidth: 1,
    opacity: 0.9058823529411765,
    d: "M 679.5 77 L 836.5 77 L 837.5 78 L 853.5 79 Q 902.4 89.6 929 122.5 Q 943.5 139 952 161.5 L 958 184.5 L 959 204.5 L 960 205.5 L 960 207.5 L 960 247.5 L 958.5 249 L 956.5 248 L 849.5 248 L 847 249 L 847 201.5 L 846 196.5 Q 839.8 175.7 825.5 163 Q 812.5 150.5 791.5 146 Q 786 147.5 784.5 145 L 716.5 145 L 701.5 148 L 686.5 155 Q 674.9 161.9 667 172.5 Q 657.5 184.5 654 202.5 L 654 520 L 657.5 520 L 711.5 466 L 768.5 518 L 770 518 L 764.5 525 L 605.5 681 L 603.5 681 L 441 519.5 L 443 516.5 L 489 469.5 L 489 468 L 491 468 Q 489.9 465.3 492.5 466 L 546.5 513 L 557 520 L 557 194.5 L 558 193.5 L 559 180.5 L 563 165.5 L 575 139.5 Q 585.2 122.7 599.5 110 Q 614.1 96.6 633.5 88 L 653.5 81 L 670.5 78 L 678.5 78 L 679.5 77 Z M 677 80 L 676 81 L 662 82 L 636 90 Q 616 99 602 112 Q 587 125 577 142 L 565 169 L 560 193 L 560 523 L 553 522 L 493 470 L 447 518 L 445 520 L 604 678 L 625 659 L 766 520 L 712 470 L 659 523 L 651 523 L 651 209 L 656 188 Q 661 175 670 166 Q 686 148 715 143 L 787 143 L 809 149 L 826 160 Q 835 169 842 181 L 848 196 L 850 207 L 850 246 L 957 246 L 957 199 L 956 198 L 955 183 Q 948 148 928 126 Q 901 91 850 81 L 842 81 L 841 80 L 677 80 Z "
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(14,78,120)",
    stroke: "rgb(14,78,120)",
    strokeWidth: 1,
    opacity: 0.9058823529411765,
    d: "M 903.5 279 L 1067 441.5 L 1016.5 494 L 956.5 443 L 951 441 L 951 769.5 Q 941.9 821.4 909.5 850 Q 895.2 863.2 876.5 872 L 857.5 879 L 836.5 883 L 663.5 883 L 639.5 878 L 612.5 866 Q 592.5 854 578 836.5 L 562 811.5 L 554 790.5 L 550 774.5 Q 551.7 768.3 549 766.5 L 549 712 L 661 712 L 661 753.5 L 663 764.5 L 670 781.5 L 684.5 799 Q 697.2 810.8 717.5 815 L 725.5 815 L 726.5 816 L 788.5 816 L 789.5 815 L 802.5 814 L 821.5 806 Q 832.5 799.5 840 789.5 Q 850.3 777.3 854 758.5 L 854 450.5 L 855 449.5 L 855 441 L 850.5 441 L 796.5 494 L 739 442.5 L 782.5 398 Q 784.8 398.8 784 396.5 L 790 391.5 L 792.5 388 L 843.5 338 L 845 338 L 847.5 334 Q 850.1 334.7 849 332 L 851 332 L 851 330.5 L 903.5 279 Z M 904 283 L 784 401 L 743 443 L 798 491 L 836 452 L 849 439 L 857 438 L 857 757 L 853 773 L 842 792 Q 826 812 797 818 L 720 818 Q 696 814 683 801 Q 670 790 663 774 L 660 765 L 659 753 L 658 752 L 658 715 L 552 715 L 552 769 L 553 770 L 554 782 Q 562 815 581 837 Q 595 853 614 864 L 641 876 L 666 881 L 836 881 L 853 878 L 869 873 Q 888 865 903 853 Q 920 839 932 819 L 941 800 L 948 772 L 948 762 L 949 761 L 949 438 L 956 439 L 1017 491 L 1063 442 L 904 283 Z "
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(14,78,120)",
    stroke: "rgb(14,78,120)",
    strokeWidth: 1,
    opacity: 0.9058823529411765,
    d: "M 1480 454 L 1619.5 454 L 1623 457.5 L 1706.5 584 L 1798.5 454 L 1937 454.5 L 1773 655.5 L 1780 662.5 L 1947 871.5 L 1807.5 872 L 1708.5 733 L 1611.5 872 L 1463.5 872 L 1463 870.5 L 1640 657.5 L 1490 466 L 1487 464.5 L 1480 454 Z M 1486 457 L 1643 658 L 1469 868 L 1470 870 L 1610 870 L 1614 866 L 1709 729 L 1805 866 L 1810 870 L 1941 870 L 1940 867 L 1770 656 L 1931 458 L 1799 457 L 1707 589 L 1620 459 L 1619 457 L 1486 457 Z "
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(14,78,120)",
    stroke: "rgb(14,78,120)",
    strokeWidth: 1,
    opacity: 0.9058823529411765,
    d: "M 244 455 L 374.5 455 L 376 456.5 L 561 870.5 L 554.5 871 L 553.5 870 L 437 870 L 402 783 L 218.5 783 L 218 784.5 L 183 870 L 66.5 870 L 65.5 871 L 59 871 L 244 455 Z M 246 458 L 63 868 L 181 868 L 216 784 L 217 781 L 403 781 L 408 792 L 432 853 L 440 868 L 557 868 L 374 460 L 373 458 L 246 458 Z "
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(14,78,120)",
    stroke: "rgb(14,78,120)",
    strokeWidth: 1,
    opacity: 0.9058823529411765,
    d: "M 1137.5 455 L 1267.5 455 L 1268 456.5 L 1453 868.5 L 1453 871 L 1446.5 870 L 1330.5 870 L 1329 868.5 L 1296 786.5 L 1293.5 783 L 1111.5 783 L 1110 784.5 L 1077 866.5 L 1074.5 870 L 958.5 870 L 952 871 L 962 845.5 L 993 778.5 L 1133 462.5 L 1137.5 455 Z M 1140 458 L 1134 468 L 956 867 L 957 868 L 1074 868 L 1108 783 L 1110 781 L 1296 781 L 1331 867 L 1332 868 L 1449 868 L 1266 460 L 1266 458 L 1140 458 Z "
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(14,78,120)",
    stroke: "rgb(14,78,120)",
    strokeWidth: 1,
    opacity: 0.9058823529411765,
    d: "M 310.5 552 L 313 555.5 L 375 711.5 L 247.5 712 L 248 710.5 L 310.5 552 Z M 311 558 L 251 710 L 280 710 L 281 709 L 368 709 L 371 710 L 311 558 Z "
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(14,78,120)",
    stroke: "rgb(14,78,120)",
    strokeWidth: 1,
    opacity: 0.9058823529411765,
    d: "M 1203.5 552 L 1267 712 L 1140.5 712 L 1140 710.5 L 1201 555.5 L 1203.5 552 Z M 1204 558 L 1201 562 L 1143 710 L 1172 710 L 1173 709 L 1261 709 L 1262 710 L 1264 710 L 1204 558 Z "
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32,131,197)",
    stroke: "rgb(32,131,197)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 675.5 160 L 674.5 162 L 675.5 160 Z "
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32,131,197)",
    stroke: "rgb(32,131,197)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 956.5 198 L 957 200.5 L 956 200.5 L 956.5 198 Z "
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32,131,197)",
    stroke: "rgb(32,131,197)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 903.5 283 L 895.5 292 L 903.5 283 Z "
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32,131,197)",
    stroke: "rgb(32,131,197)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 848.5 337 L 814.5 372 L 848.5 337 Z "
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32,131,197)",
    stroke: "rgb(32,131,197)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 986.5 365 L 1063 442.5 L 1016.5 491 L 955.5 439 L 949 438 L 948.5 761 L 948 566 L 858 566 L 858 749.5 L 857 749.5 L 857 438.5 Q 856.8 437.3 850.5 438 L 836 451.5 L 797.5 491 L 743 442.5 L 783.5 401 L 755.5 431 L 1051 430.5 L 986.5 365 Z "
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32,131,197)",
    stroke: "rgb(32,131,197)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 650.5 420 L 651 523 L 658.5 523 L 711.5 470 L 766 519.5 L 687.5 597 L 716.5 566 L 493 566.5 L 603.5 678 L 445 519.5 L 447 517.5 L 492.5 470 L 552.5 522 L 560 523 L 560 431 L 649.5 431 L 650 430.5 L 650.5 420 Z "
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32,131,197)",
    stroke: "rgb(32,131,197)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1486 457 L 1618.5 457 L 1620 458.5 L 1695 571.5 L 1693 570.5 L 1691 566 L 1572 566.5 L 1579 574.5 L 1575 571.5 L 1486 457 Z "
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32,131,197)",
    stroke: "rgb(32,131,197)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1799 457 L 1931 457.5 L 1832.5 578 L 1836 573.5 L 1841 566.5 L 1723 566 L 1718.5 573 L 1720 570.5 L 1799 457 Z "
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32,131,197)",
    stroke: "rgb(32,131,197)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 246 458 L 372.5 458 L 374 459.5 L 424 571.5 L 423 571.5 L 421 566 L 318.5 566 L 318 567.5 L 317 567.5 L 313 555.5 L 310.5 552 L 303.5 569 L 303 567.5 L 303.5 566 L 198 565.5 L 246 458 Z "
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32,131,197)",
    stroke: "rgb(32,131,197)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1139.5 458 L 1265.5 458 L 1266 459.5 L 1314 565.5 L 1210 566.5 L 1211 568.5 L 1210 568.5 L 1203.5 552 L 1196.5 568 L 1196 566 L 1091.5 566 L 1091 567.5 L 1088.5 572 L 1088 570.5 L 1134 467.5 L 1139.5 458 Z "
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32,131,197)",
    stroke: "rgb(32,131,197)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 197.5 567 L 198 568.5 L 196.5 571 L 196 569.5 L 197.5 567 Z "
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32,131,197)",
    stroke: "rgb(32,131,197)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1314.5 567 L 1316 570.5 L 1315 570.5 L 1314.5 567 Z "
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32,131,197)",
    stroke: "rgb(32,131,197)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 318.5 569 L 320 572.5 L 319 572.5 L 318.5 569 Z "
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32,131,197)",
    stroke: "rgb(32,131,197)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 302.5 570 L 303 571.5 L 301.5 574 L 301 572.5 L 302.5 570 Z "
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32,131,197)",
    stroke: "rgb(32,131,197)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1211.5 570 L 1213 573.5 L 1212 573.5 L 1211.5 570 Z "
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32,131,197)",
    stroke: "rgb(32,131,197)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1695.5 573 L 1699 577.5 L 1697 576.5 L 1695.5 573 Z "
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32,131,197)",
    stroke: "rgb(32,131,197)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 320.5 574 L 322 577.5 L 321 577.5 L 320.5 574 Z "
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32,131,197)",
    stroke: "rgb(32,131,197)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1717.5 574 L 1715.5 577 L 1717.5 574 Z "
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32,131,197)",
    stroke: "rgb(32,131,197)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 193.5 576 L 194 577.5 L 191.5 582 L 191 580.5 L 193.5 576 Z "
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32,131,197)",
    stroke: "rgb(32,131,197)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1318.5 576 L 1321 581.5 L 1320 581.5 L 1318.5 576 Z "
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32,131,197)",
    stroke: "rgb(32,131,197)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1579.5 576 L 1586 583.5 L 1582 580.5 L 1579.5 576 Z "
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32,131,197)",
    stroke: "rgb(32,131,197)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 426.5 577 L 428 580.5 L 427 580.5 L 426.5 577 Z "
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32,131,197)",
    stroke: "rgb(32,131,197)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1085.5 577 L 1086 578.5 L 1084.5 581 L 1084 579.5 L 1085.5 577 Z "
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32,131,197)",
    stroke: "rgb(32,131,197)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1714.5 578 L 1713.5 580 L 1714.5 578 Z "
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32,131,197)",
    stroke: "rgb(32,131,197)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 322.5 579 L 324 582.5 L 323 582.5 L 322.5 579 Z "
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32,131,197)",
    stroke: "rgb(32,131,197)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1191.5 579 L 1192 580.5 L 1190.5 583 L 1190 581.5 L 1191.5 579 Z "
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32,131,197)",
    stroke: "rgb(32,131,197)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1699.5 579 L 1700.5 581 L 1699.5 579 Z "
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32,131,197)",
    stroke: "rgb(32,131,197)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1831.5 579 L 1828.5 583 L 1831.5 579 Z "
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32,131,197)",
    stroke: "rgb(32,131,197)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1712.5 581 L 1711 583.5 L 1708.5 587 L 1710 584.5 L 1712.5 581 Z "
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32,131,197)",
    stroke: "rgb(32,131,197)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1701.5 582 L 1702.5 584 L 1701.5 582 Z "
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32,131,197)",
    stroke: "rgb(32,131,197)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 324.5 584 L 326 587.5 L 325 587.5 L 324.5 584 Z "
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32,131,197)",
    stroke: "rgb(32,131,197)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1189.5 584 L 1190 585.5 L 1188.5 588 L 1188 586.5 L 1189.5 584 Z "
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32,131,197)",
    stroke: "rgb(32,131,197)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1827.5 584 L 1824.5 588 L 1827.5 584 Z "
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32,131,197)",
    stroke: "rgb(32,131,197)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 189.5 585 L 190 586.5 L 187.5 591 L 187 589.5 L 189.5 585 Z "
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32,131,197)",
    stroke: "rgb(32,131,197)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1586.5 585 L 1589.5 589 L 1586.5 585 Z "
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32,131,197)",
    stroke: "rgb(32,131,197)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1703.5 585 L 1704.5 587 L 1703.5 585 Z "
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32,131,197)",
    stroke: "rgb(32,131,197)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 430.5 586 L 433 591.5 L 432 591.5 L 430.5 586 Z "
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32,131,197)",
    stroke: "rgb(32,131,197)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1081.5 586 L 1082 587.5 L 1079.5 592 L 1079 590.5 L 1081.5 586 Z "
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32,131,197)",
    stroke: "rgb(32,131,197)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1323.5 587 L 1325 590.5 L 1324 590.5 L 1323.5 587 Z "
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32,131,197)",
    stroke: "rgb(32,131,197)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1705.5 588 L 1708 588.5 Q 1705.9 591.8 1705.5 588 Z "
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32,131,197)",
    stroke: "rgb(32,131,197)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1823.5 589 L 1820.5 593 L 1823.5 589 Z "
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32,131,197)",
    stroke: "rgb(32,131,197)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1590.5 590 L 1592.5 593 L 1590.5 590 Z "
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32,131,197)",
    stroke: "rgb(32,131,197)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 293.5 593 L 294 594.5 L 292.5 597 L 292 595.5 L 293.5 593 Z "
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32,131,197)",
    stroke: "rgb(32,131,197)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1593.5 594 L 1596.5 598 L 1593.5 594 Z "
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32,131,197)",
    stroke: "rgb(32,131,197)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1818.5 595 L 1815.5 599 L 1818.5 595 Z "
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32,131,197)",
    stroke: "rgb(32,131,197)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 184.5 596 L 185 597.5 L 183.5 600 L 183 598.5 L 184.5 596 Z "
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32,131,197)",
    stroke: "rgb(32,131,197)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1327.5 596 L 1329 599.5 L 1328 599.5 L 1327.5 596 Z "
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32,131,197)",
    stroke: "rgb(32,131,197)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 435.5 597 L 437 600.5 L 436 600.5 L 435.5 597 Z "
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32,131,197)",
    stroke: "rgb(32,131,197)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1076.5 597 L 1077 598.5 L 1075.5 601 L 1075 599.5 L 1076.5 597 Z "
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32,131,197)",
    stroke: "rgb(32,131,197)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1222.5 598 L 1224 601.5 L 1223 601.5 L 1222.5 598 Z "
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32,131,197)",
    stroke: "rgb(32,131,197)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1597.5 599 L 1600.5 603 L 1597.5 599 Z "
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32,131,197)",
    stroke: "rgb(32,131,197)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1814.5 600 L 1811.5 604 L 1814.5 600 Z "
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32,131,197)",
    stroke: "rgb(32,131,197)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1601.5 604 L 1603.5 607 L 1601.5 604 Z "
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32,131,197)",
    stroke: "rgb(32,131,197)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1810.5 605 L 1807.5 609 L 1810.5 605 Z "
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32,131,197)",
    stroke: "rgb(32,131,197)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1332.5 607 L 1334 610.5 L 1333 610.5 L 1332.5 607 Z "
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32,131,197)",
    stroke: "rgb(32,131,197)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1605.5 609 L 1607.5 612 L 1605.5 609 Z "
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32,131,197)",
    stroke: "rgb(32,131,197)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1805.5 611 L 1803.5 614 L 1805.5 611 Z "
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32,131,197)",
    stroke: "rgb(32,131,197)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1608.5 613 L 1610.5 616 L 1608.5 613 Z "
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32,131,197)",
    stroke: "rgb(32,131,197)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 667.5 615 L 624.5 659 L 667.5 615 Z "
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32,131,197)",
    stroke: "rgb(32,131,197)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1801.5 616 L 1799.5 619 L 1801.5 616 Z "
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32,131,197)",
    stroke: "rgb(32,131,197)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 444.5 617 L 446 620.5 L 445 620.5 L 444.5 617 Z "
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32,131,197)",
    stroke: "rgb(32,131,197)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1612.5 618 L 1614.5 621 L 1612.5 618 Z "
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32,131,197)",
    stroke: "rgb(32,131,197)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1797.5 621 L 1794.5 625 L 1797.5 621 Z "
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32,131,197)",
    stroke: "rgb(32,131,197)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1616.5 623 L 1618.5 626 L 1616.5 623 Z "
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32,131,197)",
    stroke: "rgb(32,131,197)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1619.5 627 L 1621.5 630 L 1619.5 627 Z "
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32,131,197)",
    stroke: "rgb(32,131,197)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1792.5 627 L 1790.5 630 L 1792.5 627 Z "
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32,131,197)",
    stroke: "rgb(32,131,197)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1623.5 632 L 1625.5 635 L 1623.5 632 Z "
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32,131,197)",
    stroke: "rgb(32,131,197)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1788.5 632 L 1786.5 635 L 1788.5 632 Z "
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32,131,197)",
    stroke: "rgb(32,131,197)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1627.5 637 L 1629.5 640 L 1627.5 637 Z "
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32,131,197)",
    stroke: "rgb(32,131,197)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1784.5 637 L 1782.5 640 L 1784.5 637 Z "
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32,131,197)",
    stroke: "rgb(32,131,197)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1631.5 642 L 1632.5 644 L 1631.5 642 Z "
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32,131,197)",
    stroke: "rgb(32,131,197)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1779.5 643 L 1778.5 645 L 1779.5 643 Z "
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32,131,197)",
    stroke: "rgb(32,131,197)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1634.5 646 L 1636.5 649 L 1634.5 646 Z "
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32,131,197)",
    stroke: "rgb(32,131,197)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1775.5 648 L 1773.5 651 L 1775.5 648 Z "
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32,131,197)",
    stroke: "rgb(32,131,197)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1638.5 651 L 1640.5 654 L 1638.5 651 Z "
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32,131,197)",
    stroke: "rgb(32,131,197)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1771.5 653 L 1770.5 655 L 1771.5 653 Z "
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32,131,197)",
    stroke: "rgb(32,131,197)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1770.5 656 L 1772.5 659 L 1770.5 656 Z "
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32,131,197)",
    stroke: "rgb(32,131,197)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1642.5 658 L 1640.5 661 L 1642.5 658 Z "
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32,131,197)",
    stroke: "rgb(32,131,197)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1775.5 662 L 1776.5 664 L 1775.5 662 Z "
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32,131,197)",
    stroke: "rgb(32,131,197)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1637.5 664 L 1635.5 667 L 1637.5 664 Z "
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32,131,197)",
    stroke: "rgb(32,131,197)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1779.5 667 L 1781.5 670 L 1779.5 667 Z "
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32,131,197)",
    stroke: "rgb(32,131,197)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1632.5 670 L 1630.5 673 L 1632.5 670 Z "
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32,131,197)",
    stroke: "rgb(32,131,197)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1783.5 672 L 1785.5 675 L 1783.5 672 Z "
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32,131,197)",
    stroke: "rgb(32,131,197)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1627.5 676 L 1626.5 678 L 1627.5 676 Z "
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32,131,197)",
    stroke: "rgb(32,131,197)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1787.5 677 L 1788.5 679 L 1787.5 677 Z "
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32,131,197)",
    stroke: "rgb(32,131,197)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1622.5 682 L 1621.5 684 L 1622.5 682 Z "
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32,131,197)",
    stroke: "rgb(32,131,197)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1792.5 683 L 1793.5 685 L 1792.5 683 Z "
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32,131,197)",
    stroke: "rgb(32,131,197)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1617.5 688 L 1616.5 690 L 1617.5 688 Z "
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32,131,197)",
    stroke: "rgb(32,131,197)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1796.5 688 L 1797.5 690 L 1796.5 688 Z "
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32,131,197)",
    stroke: "rgb(32,131,197)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1613.5 693 L 1611.5 696 L 1613.5 693 Z "
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32,131,197)",
    stroke: "rgb(32,131,197)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1800.5 693 L 1801.5 695 L 1800.5 693 Z "
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32,131,197)",
    stroke: "rgb(32,131,197)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1804.5 698 L 1805.5 700 L 1804.5 698 Z "
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32,131,197)",
    stroke: "rgb(32,131,197)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1608.5 699 L 1606.5 702 L 1608.5 699 Z "
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32,131,197)",
    stroke: "rgb(32,131,197)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1808.5 703 L 1809.5 705 L 1808.5 703 Z "
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32,131,197)",
    stroke: "rgb(32,131,197)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1603.5 705 L 1602.5 707 L 1603.5 705 Z "
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32,131,197)",
    stroke: "rgb(32,131,197)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1812.5 708 L 1813.5 710 L 1812.5 708 Z "
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32,131,197)",
    stroke: "rgb(32,131,197)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1139.5 711 L 1140.5 712 L 1234 712.5 L 1139 713 L 1139.5 711 Z "
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32,131,197)",
    stroke: "rgb(32,131,197)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1598.5 711 L 1597.5 713 L 1598.5 711 Z "
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32,131,197)",
    stroke: "rgb(32,131,197)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 247.5 712 L 342 712.5 L 247.5 713 L 247.5 712 Z "
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32,131,197)",
    stroke: "rgb(32,131,197)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1816.5 713 L 1817.5 715 L 1816.5 713 Z "
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32,131,197)",
    stroke: "rgb(32,131,197)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1593.5 717 L 1592.5 719 L 1593.5 717 Z "
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32,131,197)",
    stroke: "rgb(32,131,197)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1820.5 718 L 1821.5 720 L 1820.5 718 Z "
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32,131,197)",
    stroke: "rgb(32,131,197)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1588.5 723 L 1587.5 725 L 1588.5 723 Z "
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32,131,197)",
    stroke: "rgb(32,131,197)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1584.5 728 L 1583.5 730 L 1584.5 728 Z "
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32,131,197)",
    stroke: "rgb(32,131,197)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1708.5 728 L 1709.5 730 L 1707 729.5 L 1708.5 728 Z "
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32,131,197)",
    stroke: "rgb(32,131,197)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1828.5 728 L 1829.5 730 L 1828.5 728 Z "
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32,131,197)",
    stroke: "rgb(32,131,197)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1711.5 732 L 1712.5 734 L 1711.5 732 Z "
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32,131,197)",
    stroke: "rgb(32,131,197)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1579.5 734 L 1578.5 736 L 1579.5 734 Z "
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32,131,197)",
    stroke: "rgb(32,131,197)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1833.5 734 L 1834.5 736 L 1833.5 734 Z "
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32,131,197)",
    stroke: "rgb(32,131,197)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1703.5 735 L 1702.5 737 L 1703.5 735 Z "
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32,131,197)",
    stroke: "rgb(32,131,197)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1837.5 739 L 1838.5 741 L 1837.5 739 Z "
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32,131,197)",
    stroke: "rgb(32,131,197)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1574.5 740 L 1573.5 742 L 1574.5 740 Z "
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32,131,197)",
    stroke: "rgb(32,131,197)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1841.5 744 L 1842.5 746 L 1841.5 744 Z "
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32,131,197)",
    stroke: "rgb(32,131,197)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1569.5 746 L 1568.5 748 L 1569.5 746 Z "
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32,131,197)",
    stroke: "rgb(32,131,197)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1845.5 749 L 1846.5 751 L 1845.5 749 Z "
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32,131,197)",
    stroke: "rgb(32,131,197)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1565.5 751 L 1564.5 753 L 1565.5 751 Z "
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32,131,197)",
    stroke: "rgb(32,131,197)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 658.5 752 L 659 754.5 L 658 754.5 L 658.5 752 Z "
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32,131,197)",
    stroke: "rgb(32,131,197)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1849.5 754 L 1850.5 756 L 1849.5 754 Z "
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32,131,197)",
    stroke: "rgb(32,131,197)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1560.5 757 L 1559.5 759 L 1560.5 757 Z "
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32,131,197)",
    stroke: "rgb(32,131,197)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1853.5 759 L 1854.5 761 L 1853.5 759 Z "
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32,131,197)",
    stroke: "rgb(32,131,197)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1555.5 763 L 1554.5 765 L 1555.5 763 Z "
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32,131,197)",
    stroke: "rgb(32,131,197)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1857.5 764 L 1858.5 766 L 1857.5 764 Z "
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32,131,197)",
    stroke: "rgb(32,131,197)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 217.5 780 L 402.5 780 L 404 781.5 L 402.5 781 L 217.5 781 L 217.5 780 Z "
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32,131,197)",
    stroke: "rgb(32,131,197)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1110.5 780 L 1295 780.5 L 1110.5 781 L 1110.5 780 Z "
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32,131,197)",
    stroke: "rgb(32,131,197)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1541.5 780 L 1540.5 782 L 1541.5 780 Z "
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32,131,197)",
    stroke: "rgb(32,131,197)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1536.5 786 L 1535.5 788 L 1536.5 786 Z "
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32,131,197)",
    stroke: "rgb(32,131,197)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 843.5 789 L 842.5 791 L 843.5 789 Z "
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32,131,197)",
    stroke: "rgb(32,131,197)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 838.5 795 L 834.5 800 L 838.5 795 Z "
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32,131,197)",
    stroke: "rgb(32,131,197)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 683.5 801 L 684.5 803 L 683.5 801 Z "
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32,131,197)",
    stroke: "rgb(32,131,197)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1522.5 803 L 1521.5 805 L 1522.5 803 Z "
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32,131,197)",
    stroke: "rgb(32,131,197)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1517.5 809 L 1516.5 811 L 1517.5 809 Z "
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32,131,197)",
    stroke: "rgb(32,131,197)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1894.5 810 L 1895.5 812 L 1894.5 810 Z "
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32,131,197)",
    stroke: "rgb(32,131,197)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1898.5 815 L 1899.5 817 L 1898.5 815 Z "
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32,131,197)",
    stroke: "rgb(32,131,197)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 726.5 818 L 789 818.5 L 726.5 819 L 726.5 818 Z "
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32,131,197)",
    stroke: "rgb(32,131,197)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1902.5 820 L 1903.5 822 L 1902.5 820 Z "
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32,131,197)",
    stroke: "rgb(32,131,197)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1503.5 826 L 1502.5 828 L 1503.5 826 Z "
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32,131,197)",
    stroke: "rgb(32,131,197)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1498.5 832 L 1497.5 834 L 1498.5 832 Z "
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32,131,197)",
    stroke: "rgb(32,131,197)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 581.5 836 L 582.5 838 L 581.5 836 Z "
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32,131,197)",
    stroke: "rgb(32,131,197)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 903.5 851 L 902.5 853 L 903.5 851 Z "
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32,131,197)",
    stroke: "rgb(32,131,197)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1479.5 855 L 1478.5 857 L 1479.5 855 Z "
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32,131,197)",
    stroke: "rgb(32,131,197)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1469.5 869 L 1610 869.5 L 1469.5 870 L 1469.5 869 Z "
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32,131,197)",
    stroke: "rgb(32,131,197)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1809.5 869 L 1941 869.5 L 1809.5 870 L 1809.5 869 Z "
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(43,137,200)",
    stroke: "rgb(43,137,200)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 837.5 80 L 840 80.5 L 837.5 81 L 837.5 80 Z "
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(43,137,200)",
    stroke: "rgb(43,137,200)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 594.5 119 L 591.5 123 L 594.5 119 Z "
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(43,137,200)",
    stroke: "rgb(43,137,200)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 668.5 167 L 667.5 169 L 668.5 167 Z "
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(43,137,200)",
    stroke: "rgb(43,137,200)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 956.5 201 L 957 245.5 L 956 245.5 L 956.5 201 Z "
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(43,137,200)",
    stroke: "rgb(43,137,200)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 904.5 283 L 985.5 365 L 904.5 283 Z "
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(43,137,200)",
    stroke: "rgb(43,137,200)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 894.5 292 L 871.5 316 L 894.5 292 Z "
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(43,137,200)",
    stroke: "rgb(43,137,200)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 869.5 317 L 867.5 320 L 869.5 317 Z "
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(43,137,200)",
    stroke: "rgb(43,137,200)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 650.5 360 L 651 419.5 L 650 420.5 L 650 431 L 560 431 L 560 369 L 649.5 369 L 650 368.5 L 650.5 360 Z "
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(43,137,200)",
    stroke: "rgb(43,137,200)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 817.5 369 L 989.5 369 L 1051 430.5 L 755.5 431 L 813.5 372 L 817.5 369 Z "
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(43,137,200)",
    stroke: "rgb(43,137,200)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 198 566 L 304 566.5 L 259.5 678 L 149.5 678 L 148.5 679 L 149 677.5 L 198 568.5 L 198 566 Z "
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(43,137,200)",
    stroke: "rgb(43,137,200)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 318 566 L 420.5 566 L 421 567.5 L 472 678.5 L 470.5 678 L 361.5 678 L 361 675.5 L 318 566 Z "
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(43,137,200)",
    stroke: "rgb(43,137,200)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 493.5 566 L 717 566.5 L 671.5 612 L 670 612 L 668.5 615 L 604.5 678 L 493.5 566 Z "
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(43,137,200)",
    stroke: "rgb(43,137,200)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 858 566 L 948 566 L 948 678 L 858 678 L 858 566 Z "
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(43,137,200)",
    stroke: "rgb(43,137,200)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1091 566 L 1195.5 566 L 1196 568.5 L 1153 678 L 1041 677.5 L 1091 566 Z "
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(43,137,200)",
    stroke: "rgb(43,137,200)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1210.5 566 L 1313.5 566 L 1314 568.5 L 1364 677.5 L 1255.5 678 L 1254.5 679 L 1210.5 566 Z "
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(43,137,200)",
    stroke: "rgb(43,137,200)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1572.5 566 L 1690.5 566 L 1691 567.5 L 1706.5 590 L 1723 566 L 1841 566.5 L 1773 650.5 L 1770 656.5 L 1787 678 L 1627.5 678 L 1623.5 682 L 1628 676.5 L 1643 658.5 L 1643 656.5 L 1572.5 566 Z "
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(43,137,200)",
    stroke: "rgb(43,137,200)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1789.5 680 L 1791.5 683 L 1789.5 680 Z "
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(43,137,200)",
    stroke: "rgb(43,137,200)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1621.5 684 L 1618.5 688 L 1621.5 684 Z "
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(43,137,200)",
    stroke: "rgb(43,137,200)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1793.5 685 L 1795.5 688 L 1793.5 685 Z "
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(43,137,200)",
    stroke: "rgb(43,137,200)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1797.5 690 L 1799.5 693 L 1797.5 690 Z "
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(43,137,200)",
    stroke: "rgb(43,137,200)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1615.5 691 L 1614.5 693 L 1615.5 691 Z "
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(43,137,200)",
    stroke: "rgb(43,137,200)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1801.5 695 L 1803.5 698 L 1801.5 695 Z "
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(43,137,200)",
    stroke: "rgb(43,137,200)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1611.5 696 L 1609.5 699 L 1611.5 696 Z "
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(43,137,200)",
    stroke: "rgb(43,137,200)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1806.5 701 L 1807.5 703 L 1806.5 701 Z "
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(43,137,200)",
    stroke: "rgb(43,137,200)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1606.5 702 L 1604.5 705 L 1606.5 702 Z "
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(43,137,200)",
    stroke: "rgb(43,137,200)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1810.5 706 L 1811.5 708 L 1810.5 706 Z "
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(43,137,200)",
    stroke: "rgb(43,137,200)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1601.5 708 L 1599.5 711 L 1601.5 708 Z "
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(43,137,200)",
    stroke: "rgb(43,137,200)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1267.5 711 L 1268 713 L 1234 712.5 L 1266.5 712 L 1267.5 711 Z "
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(43,137,200)",
    stroke: "rgb(43,137,200)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1814.5 711 L 1815.5 713 L 1814.5 711 Z "
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(43,137,200)",
    stroke: "rgb(43,137,200)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 342.5 712 L 375 712.5 L 342.5 713 L 342.5 712 Z "
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(43,137,200)",
    stroke: "rgb(43,137,200)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1596.5 714 L 1594.5 717 L 1596.5 714 Z "
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(43,137,200)",
    stroke: "rgb(43,137,200)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 552.5 715 L 658 715.5 L 552.5 716 L 552.5 715 Z "
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(43,137,200)",
    stroke: "rgb(43,137,200)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1818.5 716 L 1819.5 718 L 1818.5 716 Z "
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(43,137,200)",
    stroke: "rgb(43,137,200)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1591.5 720 L 1589.5 723 L 1591.5 720 Z "
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(43,137,200)",
    stroke: "rgb(43,137,200)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1823.5 722 L 1824.5 724 L 1823.5 722 Z "
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(43,137,200)",
    stroke: "rgb(43,137,200)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1586.5 726 L 1585.5 728 L 1586.5 726 Z "
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(43,137,200)",
    stroke: "rgb(43,137,200)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1581.5 732 L 1580.5 734 L 1581.5 732 Z "
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(43,137,200)",
    stroke: "rgb(43,137,200)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1831.5 732 L 1832.5 734 L 1831.5 732 Z "
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(43,137,200)",
    stroke: "rgb(43,137,200)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1704.5 733 L 1703.5 735 L 1704.5 733 Z "
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(43,137,200)",
    stroke: "rgb(43,137,200)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1577.5 737 L 1575.5 740 L 1577.5 737 Z "
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(43,137,200)",
    stroke: "rgb(43,137,200)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1835.5 737 L 1836.5 739 L 1835.5 737 Z "
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(43,137,200)",
    stroke: "rgb(43,137,200)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1717.5 740 L 1718.5 742 L 1717.5 740 Z "
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(43,137,200)",
    stroke: "rgb(43,137,200)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1839.5 742 L 1840.5 744 L 1839.5 742 Z "
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(43,137,200)",
    stroke: "rgb(43,137,200)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1571.5 744 L 1570.5 746 L 1571.5 744 Z "
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(43,137,200)",
    stroke: "rgb(43,137,200)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1843.5 747 L 1844.5 749 L 1843.5 747 Z "
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(43,137,200)",
    stroke: "rgb(43,137,200)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1567.5 749 L 1566.5 751 L 1567.5 749 Z "
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(43,137,200)",
    stroke: "rgb(43,137,200)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 857.5 750 L 858 753.5 L 857 753.5 L 857.5 750 Z "
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(43,137,200)",
    stroke: "rgb(43,137,200)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1724.5 750 L 1725.5 752 L 1724.5 750 Z "
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(43,137,200)",
    stroke: "rgb(43,137,200)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1847.5 752 L 1848.5 754 L 1847.5 752 Z "
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(43,137,200)",
    stroke: "rgb(43,137,200)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 658.5 755 L 659 757.5 L 658 757.5 L 658.5 755 Z "
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(43,137,200)",
    stroke: "rgb(43,137,200)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1562.5 755 L 1561.5 757 L 1562.5 755 Z "
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(43,137,200)",
    stroke: "rgb(43,137,200)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1729.5 757 L 1730.5 759 L 1729.5 757 Z "
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(43,137,200)",
    stroke: "rgb(43,137,200)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1851.5 757 L 1852.5 759 L 1851.5 757 Z "
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(43,137,200)",
    stroke: "rgb(43,137,200)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1557.5 761 L 1556.5 763 L 1557.5 761 Z "
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(43,137,200)",
    stroke: "rgb(43,137,200)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1684.5 762 L 1683.5 764 L 1684.5 762 Z "
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(43,137,200)",
    stroke: "rgb(43,137,200)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 552.5 763 L 553 766.5 L 552 766.5 L 552.5 763 Z "
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(43,137,200)",
    stroke: "rgb(43,137,200)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 947.5 767 L 948 769.5 L 947 769.5 L 947.5 767 Z "
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(43,137,200)",
    stroke: "rgb(43,137,200)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1552.5 767 L 1551.5 769 L 1552.5 767 Z "
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(43,137,200)",
    stroke: "rgb(43,137,200)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1736.5 767 L 1737.5 769 L 1736.5 767 Z "
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(43,137,200)",
    stroke: "rgb(43,137,200)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1860.5 768 L 1861.5 770 L 1860.5 768 Z "
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(43,137,200)",
    stroke: "rgb(43,137,200)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1547.5 773 L 1546.5 775 L 1547.5 773 Z "
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(43,137,200)",
    stroke: "rgb(43,137,200)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1864.5 773 L 1865.5 775 L 1864.5 773 Z "
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(43,137,200)",
    stroke: "rgb(43,137,200)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1543.5 778 L 1542.5 780 L 1543.5 778 Z "
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(43,137,200)",
    stroke: "rgb(43,137,200)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1868.5 778 L 1869.5 780 L 1868.5 778 Z "
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(43,137,200)",
    stroke: "rgb(43,137,200)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1109.5 780 L 1108.5 782 L 1109.5 780 Z "
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(43,137,200)",
    stroke: "rgb(43,137,200)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1872.5 783 L 1873.5 785 L 1872.5 783 Z "
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(43,137,200)",
    stroke: "rgb(43,137,200)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1538.5 784 L 1537.5 786 L 1538.5 784 Z "
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(43,137,200)",
    stroke: "rgb(43,137,200)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1748.5 784 L 1749.5 786 L 1748.5 784 Z "
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(43,137,200)",
    stroke: "rgb(43,137,200)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1876.5 788 L 1877.5 790 L 1876.5 788 Z "
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(43,137,200)",
    stroke: "rgb(43,137,200)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 672.5 790 L 673.5 792 L 672.5 790 Z "
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(43,137,200)",
    stroke: "rgb(43,137,200)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1533.5 790 L 1532.5 792 L 1533.5 790 Z "
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(43,137,200)",
    stroke: "rgb(43,137,200)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 841.5 792 L 839.5 795 L 841.5 792 Z "
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(43,137,200)",
    stroke: "rgb(43,137,200)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1880.5 793 L 1881.5 795 L 1880.5 793 Z "
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(43,137,200)",
    stroke: "rgb(43,137,200)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1528.5 796 L 1527.5 798 L 1528.5 796 Z "
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(43,137,200)",
    stroke: "rgb(43,137,200)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 833.5 800 L 832.5 802 L 833.5 800 Z "
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(43,137,200)",
    stroke: "rgb(43,137,200)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1519.5 807 L 1518.5 809 L 1519.5 807 Z "
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(43,137,200)",
    stroke: "rgb(43,137,200)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1514.5 813 L 1513.5 815 L 1514.5 813 Z "
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(43,137,200)",
    stroke: "rgb(43,137,200)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 723.5 818 L 726 818.5 L 723.5 819 L 723.5 818 Z "
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(43,137,200)",
    stroke: "rgb(43,137,200)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 789.5 818 L 793 818.5 L 789.5 819 L 789.5 818 Z "
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(43,137,200)",
    stroke: "rgb(43,137,200)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1509.5 819 L 1508.5 821 L 1509.5 819 Z "
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(43,137,200)",
    stroke: "rgb(43,137,200)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1905.5 824 L 1906.5 826 L 1905.5 824 Z "
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(43,137,200)",
    stroke: "rgb(43,137,200)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1909.5 829 L 1910.5 831 L 1909.5 829 Z "
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(43,137,200)",
    stroke: "rgb(43,137,200)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 578.5 832 L 579.5 834 L 578.5 832 Z "
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(43,137,200)",
    stroke: "rgb(43,137,200)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 918.5 836 L 917.5 838 L 918.5 836 Z "
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(43,137,200)",
    stroke: "rgb(43,137,200)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 583.5 838 L 584.5 840 L 583.5 838 Z "
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(43,137,200)",
    stroke: "rgb(43,137,200)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 591.5 846 L 594.5 850 L 591.5 846 Z "
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(43,137,200)",
    stroke: "rgb(43,137,200)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1485.5 848 L 1484.5 850 L 1485.5 848 Z "
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(43,137,200)",
    stroke: "rgb(43,137,200)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 599.5 853 L 600.5 855 L 599.5 853 Z "
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(43,137,200)",
    stroke: "rgb(43,137,200)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1471.5 865 L 1470.5 867 L 1471.5 865 Z "
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(43,137,200)",
    stroke: "rgb(43,137,200)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 667.5 880 L 670 880.5 L 667.5 881 L 667.5 880 Z "
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(43,137,200)",
    stroke: "rgb(43,137,200)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 830.5 880 L 834 880.5 L 830.5 881 L 830.5 880 Z "
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,155,197)",
    stroke: "rgb(96,155,197)",
    strokeWidth: 1,
    opacity: 0.9725490196078431,
    d: "M 686.5 80 L 829.5 80 L 830.5 81 L 852.5 82 Q 898.3 91.7 924 121.5 Q 943.1 141.9 952 172.5 L 956 194.5 L 956 222 L 851.5 222 L 851 221.5 L 851 209.5 Q 848.2 207.8 850 201.5 L 845 185.5 Q 839.2 172.3 829.5 163 Q 815 148 790.5 143 L 779.5 143 L 778.5 142 L 722.5 142 L 721.5 143 L 710.5 143 L 696.5 147 Q 677.7 154.7 666 169.5 Q 657.2 179.7 653 194.5 L 651 203.5 L 650 222 L 560.5 222 L 560 221.5 L 560 200.5 L 561 199.5 L 561 189.5 L 563 178.5 L 570 156.5 Q 582.7 127.7 605.5 109 Q 621 96 641.5 88 L 664.5 82 L 685.5 81 L 686.5 80 Z "
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,155,197)",
    stroke: "rgb(96,155,197)",
    strokeWidth: 1,
    opacity: 0.9725490196078431,
    d: "M 718.5 145 L 782.5 145 L 783.5 146 L 795.5 147 Q 820.4 154.1 834 172.5 Q 845 185.5 847 207.5 L 846 207.5 Q 839.9 182.1 821.5 169 Q 808.9 158.6 789.5 155 L 712.5 155 Q 683.3 160.8 668 180.5 L 657 199.5 L 654.5 209 L 654 203.5 Q 659.8 174.8 679.5 160 L 696.5 150 L 705.5 147 L 717.5 146 L 718.5 145 Z "
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,155,197)",
    stroke: "rgb(96,155,197)",
    strokeWidth: 1,
    opacity: 0.9725490196078431,
    d: "M 849.5 248 L 850.5 249 L 958 249 L 958 257.5 L 957.5 258 L 849 258 L 849.5 248 Z "
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,155,197)",
    stroke: "rgb(96,155,197)",
    strokeWidth: 1,
    opacity: 0.9725490196078431,
    d: "M 850.5 441 L 855 441 L 855 450 L 850.5 450 L 796.5 504 L 740 452.5 L 743.5 448 L 745.5 448 L 794.5 493 L 797.5 494 L 850.5 441 Z "
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,155,197)",
    stroke: "rgb(96,155,197)",
    strokeWidth: 1,
    opacity: 0.9725490196078431,
    d: "M 951 441 L 953.5 441 L 957.5 444 L 1016.5 495 L 1061.5 448 L 1064.5 450 L 1066 452.5 L 1016.5 504 L 958.5 454 L 953.5 450 L 951 450 L 951 441 Z "
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,155,197)",
    stroke: "rgb(96,155,197)",
    strokeWidth: 1,
    opacity: 0.9725490196078431,
    d: "M 1482 465 L 1487.5 465 L 1493 470.5 L 1640 657.5 L 1635.5 661 L 1485 470.5 L 1482 465 Z "
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,155,197)",
    stroke: "rgb(96,155,197)",
    strokeWidth: 1,
    opacity: 0.9725490196078431,
    d: "M 1928.5 465 Q 1934.6 463.8 1934 466.5 L 1777.5 659 L 1773 655.5 L 1928.5 465 Z "
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,155,197)",
    stroke: "rgb(96,155,197)",
    strokeWidth: 1,
    opacity: 0.9725490196078431,
    d: "M 446.5 525 L 604.5 682 L 764.5 525 L 768 529.5 L 647.5 649 L 604.5 691 L 603 691 L 603 689.5 L 445.5 532 Q 443.3 532.8 444 530.5 L 443 528.5 L 446.5 525 Z "
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,155,197)",
    stroke: "rgb(96,155,197)",
    strokeWidth: 1,
    opacity: 0.9725490196078431,
    d: "M 310.5 558 L 371 710 Q 367.3 711.5 368 708.5 L 310.5 566 L 254 710 Q 250.3 711.5 251 708.5 L 310.5 558 Z "
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,155,197)",
    stroke: "rgb(96,155,197)",
    strokeWidth: 1,
    opacity: 0.9725490196078431,
    d: "M 1203.5 558 L 1262 704.5 L 1263 710 L 1260 708.5 L 1203.5 567 L 1201 570.5 L 1154 691.5 L 1145.5 710 L 1143 709.5 L 1203.5 558 Z "
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,155,197)",
    stroke: "rgb(96,155,197)",
    strokeWidth: 1,
    opacity: 0.9725490196078431,
    d: "M 1708.5 733 L 1807.5 872 L 1938.5 872 L 1940 873.5 L 1945 880.5 L 1807.5 881 L 1708.5 741 L 1611.5 881 L 1465.5 881 L 1465 879.5 L 1471.5 872 L 1611.5 872 L 1614 869.5 L 1708.5 733 Z "
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,155,197)",
    stroke: "rgb(96,155,197)",
    strokeWidth: 1,
    opacity: 0.9725490196078431,
    d: "M 551.5 779 Q 560.5 822 587.5 847 Q 612.8 873.2 655.5 882 L 674.5 883 L 675.5 884 L 825.5 884 L 826.5 883 L 838.5 883 L 854.5 880 L 872.5 874 Q 900.3 861.8 919 840.5 Q 930.7 827.2 939 810.5 L 946 792.5 L 948.5 781 L 949 785.5 Q 939.2 835.2 906.5 862 Q 881.4 884.9 840.5 892 L 831.5 892 L 830.5 893 L 669.5 893 L 668.5 892 L 660.5 892 L 649.5 890 L 627.5 883 Q 601.7 871.8 584 852.5 Q 568.3 836.2 559 813.5 L 553 794.5 L 551.5 779 Z "
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,155,197)",
    stroke: "rgb(96,155,197)",
    strokeWidth: 1,
    opacity: 0.9725490196078431,
    d: "M 218 783 L 401.5 783 L 402 785.5 L 436 868.5 L 438.5 871 L 555.5 871 L 556 872.5 L 559 880 L 438.5 880 L 437 878.5 L 402 792 L 218.5 792 L 217 793.5 L 186 871.5 L 181.5 880 L 61.5 880 L 61 877.5 L 64 871 L 181.5 871 L 183 869.5 L 218 783 Z "
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(96,155,197)",
    stroke: "rgb(96,155,197)",
    strokeWidth: 1,
    opacity: 0.9725490196078431,
    d: "M 1111.5 783 L 1293.5 783 L 1295 784.5 L 1326 862.5 L 1330.5 871 L 1445.5 871 L 1446.5 870 Q 1451 873.3 1451 880 L 1330.5 880 L 1330 878.5 L 1297 797.5 L 1293.5 792 L 1110.5 792 L 1110 794.5 L 1075 880 L 953.5 880 L 953 878.5 L 957.5 871 L 1074.5 871 L 1075 869.5 L 1109 786.5 L 1111.5 783 Z "
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(59,145,203)",
    stroke: "rgb(59,145,203)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 679.5 80 L 686 80.5 L 679.5 81 L 679.5 80 Z "
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(59,145,203)",
    stroke: "rgb(59,145,203)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 830.5 80 L 837 80.5 L 830.5 81 L 830.5 80 Z "
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(59,145,203)",
    stroke: "rgb(59,145,203)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 912.5 110 L 914.5 113 L 912.5 110 Z "
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(59,145,203)",
    stroke: "rgb(59,145,203)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 600.5 113 L 595.5 119 L 600.5 113 Z "
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(59,145,203)",
    stroke: "rgb(59,145,203)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 588.5 126 L 587.5 128 L 588.5 126 Z "
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(59,145,203)",
    stroke: "rgb(59,145,203)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 723.5 142 L 779 142.5 L 723.5 143 L 723.5 142 Z "
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(59,145,203)",
    stroke: "rgb(59,145,203)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 825.5 163 L 829.5 168 L 825.5 163 Z "
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(59,145,203)",
    stroke: "rgb(59,145,203)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 560.5 195 L 561 197.5 L 560 197.5 L 560.5 195 Z "
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(59,145,203)",
    stroke: "rgb(59,145,203)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 850.5 211 L 851 245.5 L 850 245.5 L 850.5 211 Z "
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(59,145,203)",
    stroke: "rgb(59,145,203)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 850.5 248 L 957 248.5 L 850.5 249 L 850.5 248 Z "
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(59,145,203)",
    stroke: "rgb(59,145,203)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 650.5 309 L 651 359.5 L 650 360.5 L 650 369 L 560 369 L 560 322 L 649.5 322 L 650 321.5 L 650.5 309 Z "
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(59,145,203)",
    stroke: "rgb(59,145,203)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 866.5 320 L 866.5 322 L 942.5 322 L 989 368.5 L 818.5 369 L 866.5 320 Z "
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(59,145,203)",
    stroke: "rgb(59,145,203)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 751.5 453 L 753.5 456 L 751.5 453 Z "
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(59,145,203)",
    stroke: "rgb(59,145,203)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1043.5 466 L 1038.5 472 L 1043.5 466 Z "
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(59,145,203)",
    stroke: "rgb(59,145,203)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 772.5 472 L 773.5 474 L 772.5 472 Z "
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(59,145,203)",
    stroke: "rgb(59,145,203)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 782.5 481 L 783.5 483 L 782.5 481 Z "
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(59,145,203)",
    stroke: "rgb(59,145,203)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1018.5 492 L 1016.5 495 L 1018.5 492 Z "
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(59,145,203)",
    stroke: "rgb(59,145,203)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1875.5 529 L 1874.5 531 L 1875.5 529 Z "
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(59,145,203)",
    stroke: "rgb(59,145,203)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1862.5 545 L 1861.5 547 L 1862.5 545 Z "
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(59,145,203)",
    stroke: "rgb(59,145,203)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 729.5 558 L 720.5 568 L 729.5 558 Z "
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(59,145,203)",
    stroke: "rgb(59,145,203)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1849.5 561 L 1848.5 563 L 1849.5 561 Z "
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(59,145,203)",
    stroke: "rgb(59,145,203)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1836.5 577 L 1835.5 579 L 1836.5 577 Z "
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(59,145,203)",
    stroke: "rgb(59,145,203)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 667.5 619 L 657.5 630 L 667.5 619 Z "
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(59,145,203)",
    stroke: "rgb(59,145,203)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 149.5 678 L 260 678.5 L 246 712.5 L 375 713 L 373 704.5 L 362 678.5 L 470.5 678 L 510 766 L 109 765.5 L 144 687.5 L 149.5 678 Z "
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(59,145,203)",
    stroke: "rgb(59,145,203)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 858 678 L 948 678 L 948 766.5 L 946.5 766 L 855 765.5 L 858 753.5 L 858 678 Z "
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(59,145,203)",
    stroke: "rgb(59,145,203)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1041 678 L 1151.5 678 L 1152 679.5 L 1139 713 L 1267.5 713 L 1268 711.5 L 1255 678 L 1363.5 678 L 1364 680.5 L 1403 765.5 L 1002.5 766 L 1001.5 767 L 1002 765.5 L 1041 678 Z "
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(59,145,203)",
    stroke: "rgb(59,145,203)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1627.5 678 L 1787.5 678 L 1789 679.5 L 1860 767.5 L 1857.5 766 L 1735.5 766 L 1735 764.5 L 1708.5 728 L 1681.5 766 L 1554.5 766 L 1553.5 767 L 1558 761.5 L 1627.5 678 Z "
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(59,145,203)",
    stroke: "rgb(59,145,203)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 552 716 L 658 716 L 658 757.5 L 660 766 L 553.5 766 L 553 763.5 L 552 762.5 L 552 716 Z "
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(59,145,203)",
    stroke: "rgb(59,145,203)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1549.5 771 L 1548.5 773 L 1549.5 771 Z "
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(59,145,203)",
    stroke: "rgb(59,145,203)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1862.5 771 L 1863.5 773 L 1862.5 771 Z "
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(59,145,203)",
    stroke: "rgb(59,145,203)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1742.5 775 L 1743.5 777 L 1742.5 775 Z "
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(59,145,203)",
    stroke: "rgb(59,145,203)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1545.5 776 L 1544.5 778 L 1545.5 776 Z "
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(59,145,203)",
    stroke: "rgb(59,145,203)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1674.5 776 L 1673.5 778 L 1674.5 776 Z "
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(59,145,203)",
    stroke: "rgb(59,145,203)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1866.5 776 L 1867.5 778 L 1866.5 776 Z "
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(59,145,203)",
    stroke: "rgb(59,145,203)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1870.5 781 L 1871.5 783 L 1870.5 781 Z "
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(59,145,203)",
    stroke: "rgb(59,145,203)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1540.5 782 L 1539.5 784 L 1540.5 782 Z "
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(59,145,203)",
    stroke: "rgb(59,145,203)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1535.5 788 L 1534.5 790 L 1535.5 788 Z "
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(59,145,203)",
    stroke: "rgb(59,145,203)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 675.5 794 L 681.5 801 L 675.5 794 Z "
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(59,145,203)",
    stroke: "rgb(59,145,203)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1530.5 794 L 1529.5 796 L 1530.5 794 Z "
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(59,145,203)",
    stroke: "rgb(59,145,203)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1883.5 797 L 1884.5 799 L 1883.5 797 Z "
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(59,145,203)",
    stroke: "rgb(59,145,203)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1525.5 800 L 1524.5 802 L 1525.5 800 Z "
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(59,145,203)",
    stroke: "rgb(59,145,203)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 831.5 802 L 830.5 804 L 831.5 802 Z "
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(59,145,203)",
    stroke: "rgb(59,145,203)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1887.5 802 L 1888.5 804 L 1887.5 802 Z "
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(59,145,203)",
    stroke: "rgb(59,145,203)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1891.5 807 L 1892.5 809 L 1891.5 807 Z "
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(59,145,203)",
    stroke: "rgb(59,145,203)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1516.5 811 L 1515.5 813 L 1516.5 811 Z "
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(59,145,203)",
    stroke: "rgb(59,145,203)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1895.5 812 L 1896.5 814 L 1895.5 812 Z "
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(59,145,203)",
    stroke: "rgb(59,145,203)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1511.5 817 L 1510.5 819 L 1511.5 817 Z "
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(59,145,203)",
    stroke: "rgb(59,145,203)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1899.5 817 L 1900.5 819 L 1899.5 817 Z "
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(59,145,203)",
    stroke: "rgb(59,145,203)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1506.5 823 L 1505.5 825 L 1506.5 823 Z "
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(59,145,203)",
    stroke: "rgb(59,145,203)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1501.5 829 L 1500.5 831 L 1501.5 829 Z "
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(59,145,203)",
    stroke: "rgb(59,145,203)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 921.5 832 L 920.5 834 L 921.5 832 Z "
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(59,145,203)",
    stroke: "rgb(59,145,203)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1912.5 833 L 1913.5 835 L 1912.5 833 Z "
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(59,145,203)",
    stroke: "rgb(59,145,203)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1496.5 835 L 1495.5 837 L 1496.5 835 Z "
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(59,145,203)",
    stroke: "rgb(59,145,203)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 916.5 838 L 914.5 841 L 916.5 838 Z "
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(59,145,203)",
    stroke: "rgb(59,145,203)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1916.5 838 L 1917.5 840 L 1916.5 838 Z "
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(59,145,203)",
    stroke: "rgb(59,145,203)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 585.5 840 L 590.5 846 L 585.5 840 Z "
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(59,145,203)",
    stroke: "rgb(59,145,203)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1491.5 841 L 1490.5 843 L 1491.5 841 Z "
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(59,145,203)",
    stroke: "rgb(59,145,203)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1920.5 843 L 1921.5 845 L 1920.5 843 Z "
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(59,145,203)",
    stroke: "rgb(59,145,203)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 585.5 844 L 587.5 847 L 585.5 844 Z "
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(59,145,203)",
    stroke: "rgb(59,145,203)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 908.5 846 L 905.5 850 L 908.5 846 Z "
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(59,145,203)",
    stroke: "rgb(59,145,203)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1924.5 848 L 1925.5 850 L 1924.5 848 Z "
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(59,145,203)",
    stroke: "rgb(59,145,203)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1482.5 852 L 1481.5 854 L 1482.5 852 Z "
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(59,145,203)",
    stroke: "rgb(59,145,203)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 900.5 853 L 899.5 855 L 900.5 853 Z "
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(59,145,203)",
    stroke: "rgb(59,145,203)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1928.5 853 L 1929.5 855 L 1928.5 853 Z "
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(59,145,203)",
    stroke: "rgb(59,145,203)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1477.5 858 L 1476.5 860 L 1477.5 858 Z "
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(59,145,203)",
    stroke: "rgb(59,145,203)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1932.5 858 L 1933.5 860 L 1932.5 858 Z "
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(59,145,203)",
    stroke: "rgb(59,145,203)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1329.5 869 L 1330.5 870 L 1446 870.5 L 1330.5 871 L 1329.5 869 Z "
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(59,145,203)",
    stroke: "rgb(59,145,203)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 66.5 870 L 182 870.5 L 66.5 871 L 66.5 870 Z "
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(59,145,203)",
    stroke: "rgb(59,145,203)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 438.5 870 L 554 870.5 L 438.5 871 L 438.5 870 Z "
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(59,145,203)",
    stroke: "rgb(59,145,203)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 958.5 870 L 1075 870.5 L 958.5 871 L 958.5 870 Z "
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(59,145,203)",
    stroke: "rgb(59,145,203)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 670.5 880 L 675 880.5 L 670.5 881 L 670.5 880 Z "
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(59,145,203)",
    stroke: "rgb(59,145,203)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 826.5 880 L 830 880.5 L 826.5 881 L 826.5 880 Z "
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(59,145,203)",
    stroke: "rgb(59,145,203)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 675.5 883 L 826 883.5 L 675.5 884 L 675.5 883 Z "
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(61,146,204)",
    stroke: "rgb(61,146,204)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 829.5 163 L 831.5 166 L 829.5 163 Z "
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(61,146,204)",
    stroke: "rgb(61,146,204)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 650.5 214 L 651 308.5 L 650 309.5 L 650 322 L 560 322 L 560 222 L 649.5 222 L 650 221.5 L 650.5 214 Z "
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(61,146,204)",
    stroke: "rgb(61,146,204)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 851 222 L 955.5 222 L 956 222.5 L 956 246 L 851.5 246 L 851 245.5 L 851 222 Z "
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(61,146,204)",
    stroke: "rgb(61,146,204)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 903.5 284 L 942 321.5 L 866.5 322 L 903.5 284 Z "
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(61,146,204)",
    stroke: "rgb(61,146,204)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 109 766 L 510.5 766 L 511 768.5 L 556 867.5 L 439 868 L 404 780 L 216.5 780 L 216 781.5 L 183 862.5 L 179.5 868 L 64.5 868 L 64 866.5 L 109 766 Z "
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(61,146,204)",
    stroke: "rgb(61,146,204)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 553 766 L 659.5 766 L 661 767.5 Q 666.8 788.8 681.5 801 Q 694.6 813.4 715.5 818 Q 721 816.5 722.5 819 L 793.5 819 L 804.5 817 L 821.5 810 Q 834.3 802.8 843 791.5 L 853 774.5 L 855 766 L 946.5 766 L 947 766.5 L 947 773.5 L 943 791.5 L 933 815.5 Q 923.3 832.8 909.5 846 Q 893.7 861.7 871.5 871 L 857.5 876 L 838.5 880 L 826.5 880 L 825.5 881 L 675.5 881 L 674.5 880 L 661.5 880 L 650.5 878 L 628.5 871 Q 599.7 858.3 581 835.5 Q 569.5 822 562 804.5 Q 554.2 787.9 553 766 Z "
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(61,146,204)",
    stroke: "rgb(61,146,204)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1002.5 766 L 1402.5 766 L 1403 767.5 L 1448 868 L 1332.5 868 L 1331 866.5 L 1300 788.5 L 1295.5 780 L 1108.5 780 L 1108 782.5 L 1073 868 L 957.5 868 L 957 865.5 L 1002.5 766 Z "
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(61,146,204)",
    stroke: "rgb(61,146,204)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1554.5 766 L 1681 766.5 L 1611 869 L 1469 868.5 L 1554.5 766 Z "
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(61,146,204)",
    stroke: "rgb(61,146,204)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1736.5 766 L 1857.5 766 L 1862 770.5 L 1941 868.5 L 1808 869 L 1736.5 766 Z "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAjaxLogo);
export default __webpack_public_path__ + "static/media/AJAX-Logo.bff682016456efeeade5b85cb2587bde.svg";
export { ForwardRef as ReactComponent };